/* eslint-disable no-undef */

export default function AutoComplete({ elem, resultType, formMappings }) {
  if (!elem) {
    return;
  }

  const componentForm = {
    street_number: 'short_name',
    subpremise: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  };

  const getElementById = (id) => document.getElementById(id);

  const deleteAddress = () => {
    Object.values(formMappings).forEach((id) => {
      const element = getElementById(id);
      if (element) {
        element.value = '';
      }
    });
  };

  const updateOrgName = (source, newName) => {
    const nameId = formMappings.name;
    if (!nameId) {
      return null;
    }

    const nameField = getElementById(nameId);
    if (!nameField) {
      return null;
    }

    let name;
    if (source === 'fill') {
      name = newName;
    } else if (source === 'input') {
      name = elem.value;
    } else {
      name = null;
    }
    nameField.value = name;
    return name;
  };

  const fillInAddressElement = (id, value) => {
    const element = getElementById(id);
    if (element) {
      element.value = element.value ? `${element.value} ${value}` : value;
    }
  };

  const fillInAddress = (place) => {
    if (!place.place_id || !place.address_components) {
      return;
    }

    deleteAddress();
    updateOrgName();

    place.address_components.forEach((component) => {
      const [addressType] = component.types;
      const formId = formMappings[addressType];
      if (formId && componentForm[addressType]) {
        const value = component[componentForm[addressType]];
        fillInAddressElement(formId, value);
      }
    });

    if (place.name) {
      updateOrgName('fill', place.name);
    }
  };

  const isAutocompleteOpen = () => {
    const pacContainer = document.querySelector('.pac-container');
    const isOpen = pacContainer && pacContainer.offsetParent !== null;
    return isOpen;
  };

  const simulateArrowDown = () => {
    const event = new KeyboardEvent('keydown', {
      key: 'ArrowDown',
      keyCode: 40,
      which: 40,
      bubbles: true
    });
    elem.dispatchEvent(event);
  };

  const wrapKeyDownListener = (input) => {
    const originalAddEventListener = input.addEventListener.bind(input);

    input.addEventListener = (type, listener, options) => {
      if (type === 'keydown') {
        const wrappedListener = (event) => {
          const suggestionSelected =
            document.querySelector('.pac-item-selected') !== null;
          if (event.key === 'Enter' && !suggestionSelected) {
            simulateArrowDown();
          }
          listener(event);
        };
        originalAddEventListener(type, wrappedListener, options);
      } else {
        originalAddEventListener(type, listener, options);
      }
    };
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && isAutocompleteOpen()) {
      event.preventDefault();
    }
  };

  const initializeAutocomplete = () => {
    const autocompleteInstance = new google.maps.places.Autocomplete(elem, {
      componentRestrictions: { country: 'us' },
      types: Array.isArray(resultType) ? resultType : [resultType]
    });

    autocompleteInstance.addListener('place_changed', () => {
      const place = autocompleteInstance.getPlace();
      fillInAddress(place);
    });
  };

  const init = () => {
    wrapKeyDownListener(elem);
    initializeAutocomplete();
    elem.addEventListener('keydown', handleKeyDown);
  };

  init();
}
